/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-10-09 17:51:05
 * @LastEditors: caiqin.xie
 * @message: 内容快速定位导航
 */
import React, { useState, useEffect } from "react";
import { Anchor } from '@arco-design/web-react';
import styles from "../../index.module.scss";
const AnchorLink = Anchor.Link;

interface IRegular {
  id: string;
  name: string;
}

interface IProps {
  ctry: string;
  words: Record<string, string>;
  regular: IRegular[]; // 文章内容锚点
}


const ContentNav = (props:IProps) => {
  const {ctry, words, regular} = props
  const [isFixed, setIsFixed] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const winHeight = document.body.clientHeight;
      if(winHeight - scrollTop < 1500) {
        setIsFixed(false)
      } else {
        setIsFixed(true)
      }
    };
  
    window.addEventListener("scroll", handleScroll);
  
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  

  return (
    <div className={`${styles['blog-left']} ${styles['p-show']}`}>
      {/* Table of contents */}
      <Anchor
        className={styles['blog-nav-wrap']}
        offsetTop={60}
        lineless
        boundary={100}
        affix={isFixed}
        hash={false}>
        <h3 className={styles['blog-nav-title']}>{words?.blog_article_nav_title}</h3>
        {regular && regular.map(item => (
          <AnchorLink
            className={styles['blog-nav-item']}
            key={item.id}
            href={`#${item.id}`}
            title={<span dangerouslySetInnerHTML={{ __html: item?.name }}></span>} />
        ))}
      </Anchor>
    </div>
  )
}
export default ContentNav